
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}.splide{position:relative;margin-left:0.5rem;margin-right:0.5rem}:host(:not([site='BH'])) .splide__pagination{display:none}.splide__arrows{position:absolute;z-index:40;width:100%;
  aspect-ratio:16 / 9}.splide__arrow{position:absolute;top:30%;display:flex;height:3.5rem;width:3.5rem;flex-grow:1;align-items:center;justify-content:center;border-radius:9999px;border-style:none;background-color:var(--neutral-white);color:var(--primary-blue-light-1);

  box-shadow:var(--brand-shadow);}.splide__arrow--prev{left:-1.25rem}.splide__arrow--next{right:-1.25rem}.splide__arrow:hover{cursor:pointer}.splide__arrow:disabled{cursor:not-allowed}.splide__arrow:disabled{color:var(--neutral-gray-3)}.splide__slide.is-visible{visibility:visible}.sr-only{
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  border:0;
}:host(:not([site='BH'])) .slide-count{position:absolute}:host(:not([site='BH'])) .slide-count{top:.25rem}:host(:not([site='BH'])) .slide-count{right:.25rem}:host(:not([site='BH'])) .slide-count{z-index:50}:host(:not([site='BH'])) .slide-count{display:block}:host(:not([site='BH'])) .slide-count{border-radius:0.25rem}:host(:not([site='BH'])) .slide-count{padding-top:0.25rem;padding-bottom:0.25rem}:host(:not([site='BH'])) .slide-count{padding-left:0.5rem;padding-right:0.5rem}:host(:not([site='BH'])) .slide-count{font-family:var(--ff-body)}:host(:not([site='BH'])) .slide-count{font-size:var(--fs-lg);line-height:var(--lh-lg)}:host(:not([site='BH'])) .slide-count{color:var(--neutral-white)}:host(:not([site='BH'])) .slide-count{

    background-color:#00000080;
  }@media (min-width: 480px){
  .splide__arrow{top:40%}

  .slide-count{top:.75rem}

  .slide-count{right:.75rem}
}@media (min-width: 768px){
  .splide{margin-left:2rem;margin-right:2rem}

  .splide__arrow{height:4rem}

  .splide__arrow{width:4rem}

    .splide__arrow--prev{left:-2rem}

    .splide__arrow--next{right:-2rem}

  .slide-count{top:1rem}

  .slide-count{right:1rem}
}@media (min-width: 1024px){
  .splide{margin-left:2.5rem;margin-right:2.5rem}

  .splide__arrow{height:5rem}

  .splide__arrow{width:5rem}

    .splide__arrow--prev{left:-2.5rem}

    .splide__arrow--next{right:-2.5rem}
}:host([site='BH']) .splide__arrow{border-width:1px}:host([site='BH']) .splide__arrow{border-style:solid}:host([site='BH']) .splide__arrow{border-color:var(--bh-brand-primary-default)}:host([site='BH']) .slide-count{display:flex}:host([site='BH']) .slide-count{justify-content:center}:host([site='BH']) .slide-count span.current, :host([site='BH']) .slide-count span.total{font-weight:var(--fw-bold)}:host([site='BH']) .splide__pagination{padding:0px}:host([site='BH']) .splide__pagination .splide__pagination__page{margin-left:0.5rem;margin-right:0.5rem}:host([site='BH']) .splide__pagination .splide__pagination__page{height:0.75rem}:host([site='BH']) .splide__pagination .splide__pagination__page{width:0.75rem}:host([site='BH']) .splide__pagination .splide__pagination__page{cursor:pointer}:host([site='BH']) .splide__pagination .splide__pagination__page{border-radius:9999px}:host([site='BH']) .splide__pagination .splide__pagination__page{border-style:none}:host([site='BH']) .splide__pagination .splide__pagination__page{background-color:var(--bh-neutral-dark)}:host([site='BH']) .splide__pagination .splide__pagination__page.is-active{background-color:var(--bh-brand-primary-default)}
`;